
<div class="row my-2 justify-content-center">

  <div class="col-md-3">
    <mat-form-field floatLabel="never">
      <mat-label>Table Columns</mat-label>
      <mat-select (selectionChange)="tableColumnChange($event.value)" multiple>
        @for (data of AllTableColumn; track data) {
          <mat-option [value]="data"> {{ data?.title | titlecase}} </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="col-md-3">
    <button (click)="downloadExcel()" class="mx-1" color="primary" mat-raised-button>
      <mat-icon>cloud_download</mat-icon> Export Excel File
    </button>
  </div>

  <!--    <button [printStyle]="{h2 : {'font-size': '20px !important'},  h3: {'font-size': '16px !important'}, canvas: {'display': 'block !important'} }"-->
  <!--            [useExistingCss]="true" color="warn" mat-raised-button ngxPrint printSectionId="printSection"  printTitle="{{ title}}">-->
  <!--      <mat-icon>print</mat-icon> Print-->
<!--    </button>-->

</div>

<div class="col-md-12" id="printSection">

  <cdk-virtual-scroll-viewport appendOnly class="report-viewport" itemSize="5">
    <table class="table mat-elevation-z1 align-middle custom-table bg-light">
      <thead class="">
        <tr>
          @for (tableColumn of selectedTableColumn; track tableColumn; let i = $index) {
            <th class="{{ tableColumn?.theadCellClass}}"> {{tableColumn.title}} </th>
          }
        </tr>
      </thead>
      <tbody class="border-top-0">

        <tr *cdkVirtualFor="let tableData of tableData$ | async; let j = index">

          @for (tableColumn of selectedTableColumn; track tableColumn; let m = $index) {
            <td class="{{ tableColumn?.tbodyCellClass}}">
              <!--index cell-->
              @if (tableColumn.type === tableColumnType.index) {
                {{ j + 1}}
              }
              <!--/ index cell-->
              <!-- text or html cell-->
              @if ((tableColumn.type == tableColumnType.text || tableColumn.type == null || tableColumn.type == undefined) && !tableColumn?.isActionColumn) {
                <span [innerHTML]="getObjectValue(tableData, tableColumn.keyword)"></span>
              }
              <!--/ text or html cell-->
              <!-- url cell-->
              @if (tableColumn.type == tableColumnType.url) {
                <a href="{{getObjectValue(tableData, tableColumn.keyword)}}" target="_blank"><span [innerHTML]="getObjectValue(tableData, tableColumn.keyword)"></span></a>
              }
              <!--/ url cell-->
              <!-- img cell-->
              @if (tableColumn.type == tableColumnType.img) {
                @if (getObjectValue(tableData, tableColumn.keyword)) {
                  <img [src]="'data:image/jpg;base64,' + getObjectValue(tableData, tableColumn.keyword) | safeResource" alt="img"
                    style="border-radius: 8px; width: 100px">
                  } @else {
                    <mat-icon style="font-size: 50px;color: #d8dbe0;">face</mat-icon>
                  }
                }
                <!--/ img cell-->
                <!--number cell-->
                @if (tableColumn.type == tableColumnType.number) {
                  {{ tableData[tableColumn.keyword] | number}}
                }
                <!--/ number cell-->
                <!--date cell-->
                @if (tableColumn.type === tableColumnType.date) {
                  {{ tableData[tableColumn.keyword] | date : tableColumn.dateFormat}}
                }
                <!--/ date column-->
                <!--projection cell-->
                @if (tableColumn.type === tableColumnType.projection) {
                  <ng-content select="[{{ tableColumn.keyword}}]"></ng-content>
                }
                <!--/ projection column-->
              </td>
            }

          </tr>

        </tbody>
      </table>
    </cdk-virtual-scroll-viewport>
  </div>

  <div class="col-md-12 text-center">
    <p>{{ 'app-name' | translate}} &copy; {{ today | date: 'yyyy' }} </p>
  </div>
